__turbopack_context__.v({
  "ad": "Ad-module__clnCiG__ad",
  "adUnit": "Ad-module__clnCiG__adUnit",
  "adsNotVisible": "Ad-module__clnCiG__adsNotVisible",
  "border": "Ad-module__clnCiG__border",
  "divider": "Ad-module__clnCiG__divider",
  "loader": "Ad-module__clnCiG__loader",
  "placeholderAd": "Ad-module__clnCiG__placeholderAd",
  "pulse": "Ad-module__clnCiG__pulse",
  "scaleUp": "Ad-module__clnCiG__scaleUp",
  "text": "Ad-module__clnCiG__text",
  "wrapper": "Ad-module__clnCiG__wrapper",
});
